/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown>, pct: NonNullable<unknown> }} Quick_Workout_Notice_Focus_FatiguedInputs */

const en_us2_quick_workout_notice_focus_fatigued = /** @type {(inputs: Quick_Workout_Notice_Focus_FatiguedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} is still recovering (${i?.pct}%). The session follows what you asked; go lighter.`)
};

const pt_br2_quick_workout_notice_focus_fatigued = /** @type {(inputs: Quick_Workout_Notice_Focus_FatiguedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ainda está se recuperando (${i?.pct}%). O treino segue o que você pediu; vá mais leve.`)
};

const es_419_quick_workout_notice_focus_fatigued = /** @type {(inputs: Quick_Workout_Notice_Focus_FatiguedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} aún se está recuperando (${i?.pct}%). El entrenamiento sigue lo que pediste; ve más ligero.`)
};

const pt_pt2_quick_workout_notice_focus_fatigued = /** @type {(inputs: Quick_Workout_Notice_Focus_FatiguedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ainda está a recuperar (${i?.pct}%). O treino segue o que pediste; vai mais leve.`)
};

const fr_fr2_quick_workout_notice_focus_fatigued = /** @type {(inputs: Quick_Workout_Notice_Focus_FatiguedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} récupère encore (${i?.pct} %). La séance suit ta demande ; vas-y plus léger.`)
};

const de_de2_quick_workout_notice_focus_fatigued = /** @type {(inputs: Quick_Workout_Notice_Focus_FatiguedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} erholt sich noch (${i?.pct}%). Das Training folgt deinem Wunsch; geh es leichter an.`)
};

const it_it2_quick_workout_notice_focus_fatigued = /** @type {(inputs: Quick_Workout_Notice_Focus_FatiguedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} è ancora in recupero (${i?.pct}%). La sessione segue ciò che hai chiesto; usa carichi più leggeri.`)
};

/**
* | output |
* | --- |
* | "{muscle} is still recovering ({pct}%). The session follows what you asked; go lighter." |
*
* @param {Quick_Workout_Notice_Focus_FatiguedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_notice_focus_fatigued = /** @type {((inputs: Quick_Workout_Notice_Focus_FatiguedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Notice_Focus_FatiguedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_notice_focus_fatigued(inputs)
	if (locale === "es-419") return es_419_quick_workout_notice_focus_fatigued(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_notice_focus_fatigued(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_notice_focus_fatigued(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_notice_focus_fatigued(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_notice_focus_fatigued(inputs)
	return en_us2_quick_workout_notice_focus_fatigued(inputs)
});
export { quick_workout_notice_focus_fatigued as "quick-workout.notice_focus_fatigued" }